module.exports = __webpack_public_path__ + "static/media/Health-Screen.200819b1.png";